import { render, staticRenderFns } from "./Communicator.vue?vue&type=template&id=61fd0605&scoped=true&"
import script from "./Communicator.vue?vue&type=script&lang=js&"
export * from "./Communicator.vue?vue&type=script&lang=js&"
import style0 from "./Communicator.vue?vue&type=style&index=0&id=61fd0605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd0605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fd0605')) {
      api.createRecord('61fd0605', component.options)
    } else {
      api.reload('61fd0605', component.options)
    }
    module.hot.accept("./Communicator.vue?vue&type=template&id=61fd0605&scoped=true&", function () {
      api.rerender('61fd0605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Communicator.vue"
export default component.exports